export default "__VITE_ASSET__Daae3PqE__"